export  function extractDomain(urlOrDomain: string): string | null {
  try {
    const trimmed = urlOrDomain.trim().toLowerCase();

    if (/^[a-z0-9.-]+\.[a-z]{2,}$/i.test(trimmed)) {
      return trimmed.replace(/^www\./, '');
    }

    const match = trimmed.match(
      /^(?:https?:\/\/)?(?:www\.)?([^\/:?#]+)(?:[\/:?#]|$)/i,
    );

    if (match && match[1]) {
      return match[1].replace(/^www\./, '');
    }

    return null;
  } catch (e) {
    console.error('Failed to extract domain from:', urlOrDomain, e.message);
    return null;
  }
}

export function isValidCompanyEmail(email: string, domain: string): boolean {
  if (!email) return false;

  const emailDomain = email.split('@')[1]?.toLowerCase();
  const normalizedInstituteDomain = extractDomain(domain);

  if (!emailDomain || !normalizedInstituteDomain) return false;

  // Exact match or subdomain ending with `.<domain>`
  return (
    emailDomain === normalizedInstituteDomain ||
    emailDomain.endsWith(`.${normalizedInstituteDomain}`)
  );
}